// /* eslint-disable */
import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
// import { Card, CardActionArea, CardActions, CardContent, CardMedia, Tooltip } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import info from "../../data/info.json";
// import Zoom from '@mui/material/Zoom';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SocialNetworks from "../UI/SocialNetworks";
// import AboutMe from "../UI/AboutMe";
// import { ME_ROUTE } from "../../routes/consts";
import CodeIcon from "@mui/icons-material/Code";
import AddIcon from "@mui/icons-material/Add";
import StorageIcon from "@mui/icons-material/Storage";

const Taplink = () => {
    document.title = info.title;
    // const history = useNavigate();

    const links = [
        [
            "https://roso1nik.github.io/truth-or-dare/",
            'Игра "Правда или действие?" ',
        ],
        ["https://roso1nik.github.io/shaverma-tour/", "Фан проект про ша..."],
        [
            "https://roso1nik.github.io/beginner-projects/",
            "Проекты для начинающих на React",
        ],
        [
            "https://roso1nik.github.io/artist-taplink/",
            "Taplink для треков артистов",
        ],
    ];

    return (
        <main>
            <h1 className="big-title">{info.pre_emoji}</h1>
            <Box sx={{ my: 3 }} className="flex-row gap-1 jcsb mftm">
                <div>
                    <Typography variant="h2">{info.title}</Typography>
                </div>
                <SocialNetworks />
            </Box>

            <Box sx={{ mb: 1 }} className="flex-column gap-1 links links_f">
                {" "}
                {/* backLinks */}
                <Box className="flex-column gap-0 wrap">
                    <Box className="flex-row gap-0 wrap">
                        <CodeIcon className="note" />
                        <Chip label="JavaScript" className="bg-js" />
                        <Chip label="TypeScript" className="bg-ts" />
                        <Chip label="NodeJS" className="bg-node" />
                        <Chip label="React" className="bg-react" />
                        <Chip label="HTML" variant="outlined" />
                        <Chip label="CSS" variant="outlined" />
                        <Chip label="Git" variant="outlined" />
                    </Box>
                    <Box className="flex-row gap-0 wrap">
                        <AddIcon className="note" />
                        <Chip label="Next.js" variant="outlined" />
                        <Chip label="React Router" variant="outlined" />
                        <Chip label="Redux Toolkit" variant="outlined" />
                        <Chip label="SCSS" variant="outlined" />
                    </Box>
                    <Box className="flex-row gap-0 wrap">
                        <StorageIcon className="note" />
                        <Chip label="SQL" variant="outlined" />
                        <Chip label="PostgreSQL" variant="outlined" />
                        <Chip label="MongoDB" variant="outlined" />
                    </Box>
                </Box>
                {/* <AboutMe /> */}
                {links.length !== 0 ? (
                    <>
                        <Typography variant="h4" className="note_second">
                            Проекты
                        </Typography>
                        {Object.keys(links).map((link) => (
                            <Button
                                key={Math.random()}
                                onClick={() =>
                                    window.open(`${links[link][0]}`, "_blank")
                                }
                            >
                                {links[link][1]}
                            </Button>
                            // <Card>
                            //     <CardContent className="flex-row">
                            //         <Button onClick={() => window.open(`${links[link][0]}`, "_blank")}>
                            //             {links[link][1]}
                            //         </Button>
                            //         <Tooltip
                            //             TransitionComponent={Zoom}
                            //             title={links[link][0]}
                            //             className="showURL bsu_f"
                            //             arrow
                            //         >
                            //             <Button>
                            //             <ArrowDropDownIcon />
                            //         </Button>
                            //     </Tooltip>
                            //     </CardContent>
                            // </Card>
                        ))}
                        <div className="flex-row note">
                            <Typography variant="subtitle2">
                                a также мои остальные&nbsp;
                            </Typography>
                            <Typography variant="subtitle2">
                                <a
                                    href="https://github.com/roso1nik?tab=repositories"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    репозитории
                                </a>
                            </Typography>
                            <Typography variant="subtitle2">
                                &nbsp;и этот таплинк :)
                            </Typography>
                        </div>
                    </>
                ) : (
                    <></>
                )}
            </Box>
            {/* ADD NEW BELOW */}
            {/* <Box 
                sx={{ my: 5 }}
                className="custom flex-column wrap gap-1 wfull jcsb"
            >
                <h4 className="note_second">Статьи</h4>
                <Card className="flex-row">
                    <CardMedia
                        component="img"
                        alt="green iguana"
                        height="140"
                        className="ic_f"
                        image=""
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Статья
                        </Typography>
                        <Typography variant="body2">
                            Lizards are a widespread group of squamate reptiles, with over 6,000
                            species, ranging across all continents except Antarctica
                        </Typography>
                        <CardActions sx={{p: 0}}>
                            <Button 
                                variant="contained"
                                size="small"
                                sx={{mt: 1}}
                            >
                                Перейти
                            </Button>
                        </CardActions>
                    </CardContent>
                </Card>
            </Box> */}
            {/* <Box sx={{my: 1, mt: 3}} className="flex-column gap-1 links">
                <h4 className="note_second mt-2">Мои соц. сети</h4>
            </Box> */}
        </main>
    );
};

export default Taplink;
